// src/components/Dashboard/Dashboard.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebase/firebase";
import LicenseList from "./LicenseList";
import EmployeeList from "./EmployeeList";
import { collection, getDocs } from "firebase/firestore";
import { Tabs, Tab, Container } from "react-bootstrap";
import logo from '../../assets/big-logo.png'; // Import the logo
import './Dashboard.css'; // Import the CSS file
import { useUserAuth } from "../../contexts/authContext";

const Dashboard = () => {
  const [licenses, setLicenses] = useState([]);
  const [employees, setEmployees] = useState([]);
  const { logOut, user } = useUserAuth();
  // Fetch licenses from Firestore
  useEffect(() => {
    const fetchLicenses = async () => {
      const querySnapshot = await getDocs(collection(db, "licenses"));
      setLicenses(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    };
    fetchLicenses();
  }, []);

  // Fetch employees from Firestore
  useEffect(() => {
    const fetchEmployees = async () => {
      const querySnapshot = await getDocs(collection(db, "employees"));
      setEmployees(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    };
    fetchEmployees();
  }, []);
  const handleLogout = async () => {
    try {
      await logOut();
      navigate("/");
    } catch (error) {
      console.log(error.message);
    }
  };
  const navigate = useNavigate();
  return (
    <Container className=" dashboard ">
      <div className="dashboard-header">
        <div className="dashboard-logo-container">
        <img src={logo} alt="Logo" style={{ height: '50px', marginLeft: '10px' }} />
        <h1>ניהול רשיונות</h1>
        </div>
       
        <div className="user-container">
         
        {user && <strong>{user.email}</strong>}
          <div className="navbar-logout-container">
            <button type="button" className=" btn btn-danger" onClick={handleLogout}>התנתק</button>

          </div>
        </div>
      </div>
      <Tabs defaultActiveKey="licenses" id="dashboard-tabs" className="mb-3">
        <Tab eventKey="licenses" title="רשיונות">
          <LicenseList licenses={licenses} />
        </Tab>
        <Tab eventKey="employees" title="עובדים">
          <EmployeeList employees={employees} />
        </Tab>
      </Tabs>
    </Container>
  );
};

export default Dashboard;
